import { useContext, useEffect } from 'react';
import './index.less';
import { EngineContext, RegisterContext } from '@/App';
import { SIDEBAR_TYPE, TOOL_TYPE } from '@/declare/enums/menu-type';


export default function SystemLibMenuBar() {

    const registerContext = useContext(RegisterContext);
    const engineContext = useContext(EngineContext);

    // useEffect(() => {
    //     console.log('registerContext.systemLibMenus', registerContext.systemLibMenus)
    //     registerContext.systemLibMenus.forEach(lib => {
    //         console.log('lib.menuItem', lib);
    //     })
    // }, [])

    return (
        <div className='system-lib-menu'>
            {registerContext.systemLibMenus.map((libMenu, index) => {
                return <div className='lib-menu-item' key={index}>
                    <div className='nav-second-horizontal lib-menu-item-title'>{libMenu?.title}</div>
                    <div className='lib-menu-item-content'>
                        <libMenu.menuItem {...engineContext}
                            currentActivedSidebarKey={registerContext.currentActivedSidebarKey}
                            currentActivedToolKey={registerContext.currentActivedToolKey}
                            activeSidebarPanel={(key: string) => {
                                registerContext.activeSidebar(key);
                            }} activeToolPanel={(key: string) => {
                                registerContext.activeTool(key);
                            }} coreSidebarType={SIDEBAR_TYPE} coreToolType={TOOL_TYPE} />
                    </div>
                </div>
            })}
        </div>
    )
}